<template>
    <div class="practitioner-appointments mt-page">
        <h1>{{ $i18n.gt('HEADING_APPOINTMENTS') }}</h1>
        <appointment-calendar :practitioner-view="true"/>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'PractitionerAppointments',
    props: {
        practitionerId: Number
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

</style>
